/**
 * Shared design tokens for the report components.
 *
 * These map to CSS variables defined in `src/styles/reema-theme.css`. Import
 * from here instead of redeclaring the same const block at the top of every
 * report component so theme edits only need to happen in one place.
 */

export const foreground = "var(--reema-midnight-100)";
export const muted = "var(--reema-midnight-75)";
export const accent = "var(--reema-coral-100)";
export const border = "var(--reema-midnight-10)";
export const secondary = "var(--reema-sand-100)";
export const display = "var(--reema-font-display)";
export const body = "var(--reema-font-body)";

/** Brand color tokens exposed as raw values for chart primitives that
 *  don't accept CSS custom properties directly (e.g. Recharts fills). */
export const CORAL = "var(--reema-coral-100)";
export const NAVY = "var(--reema-midnight-100)";
export const SEAGREEN = "var(--reema-seagreen-100)";
